import { FormSubmission } from '../base/formSubmission' // eslint-disable-line no-unused-vars
import { FormTemplateRuleParameterType } from './formTemplateRuleParameterType'
/**
 * A form template contains one or more rules to process the form submission.
 *
 * @export
 * @class FormTemplate
 */
export class FormTemplate {
  constructor (name, rules) {
    this.version = 1
    this.name = name
    this.identifier = this.identifierFromName(name)
    this.keypath = this.identifier
    this.rules = rules
  }

  /**
   * Processes all of the template's rules on the submission.
   *
   * @param {FormSubmission} submission The submission to process or an object to convert into a submission.
   * @returns A new submission, after processing all of the rules.
   * @memberof FormTemplate
   */
  processSubmission (submission) {
    let output = submission
    this.rules.forEach(function (rule) {
      output = this.runRule(rule, output)
    }, this)
    return output
  }

  /**
   * Processes a single rule on the submission.
   *
   * @param {FormTemplateRule} rule A rule to process the submission with.
   * @param {FormSubmission} submission The submission to process.
   * @returns An updated submission.
   * @memberof FormTemplate
   */
  runRule (rule, submission) {
    return rule.run(submission)
  }

  /**
   * Generates an identifier based on the user visible name.
   *
   * @param {any} name The name of the form.
   * @returns An identifier.
   * @memberof Form
   */
  identifierFromName (name) {
    if (!name) {
      throw new Error('No name to generate template identifier.')
    }
    return 'io.owal.template.' + name.toLowerCase().replace(/\W/g, '')
  }

  // MARK: - UI Support

  /**
   * Returns a list of the fields for parameters.
   *
   * @returns A list of fields used to collect parameters in the template.
   * @memberof FormTemplate
   */
  get parameterFields () {
    const fields = this.rules.filter(rule => rule.type === FormTemplateRuleParameterType.FORM_FIELD).reduce(function (previous, current, index, array) {
      if (current && current.parameters) {
        return previous.concat(current.parameters)
      }
      return previous
    }, [])
    return fields
  }

  /**
  * Returns the rule matching a given Id, if it exists.
  *
  * @param {any} identifier The ruleId to search for.
  * @returns A FormTemplateRule, if a match is found. Otherwise, `undefined`.
  * @memberof FormTemplate
  */
  ruleForId (identifier) {
    const rule = this.rules.find(element => element.identifier === identifier)
    return rule
  }
}
